/*
 * @Author: swmonk
 * @Date: 2020-11-25 13:13:53
 * @LastEditTime: 2020-11-25 13:25:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ufun-new-bc/src/store/reducer/token.js
 */
import { createSlice, } from '@reduxjs/toolkit'
export default createSlice({
    name: 'token',
    initialState: '',
    reducers: {
        save: (state,action) => action.payload,
        clear: () => '',
    },
})